export enum GridLayoutBreakpoint {
  Large = 'lg',
  Medium = 'md',
  Small = 'sm',
  ExtraSmall = 'xs',
  ExtraExtraSmall = 'xxs',
}
